import { GET_ATTENDEES } from 'api/graphql/v2/queries/Attendees';
import { SearchWrapper } from 'components/calendar/calendarFiltersAndSearch/style';
import { useCallback, useRef, useState } from 'react';
import { useLazyQuery } from 'react-apollo';
import { AsyncTypeahead, AsyncTypeaheadProps } from 'react-bootstrap-typeahead';
import Loader from '../../../views/components/ui/content/Loader';
import searchIcon from 'assets/img/bars-search-search-bar.svg';

interface OptionType {
  displayName: string;
}
interface IProps {
  clientSearch: string;
  onclientSearchChange: (value: any) => void;
  setClientList: React.Dispatch<React.SetStateAction<OptionType[]>>;
  clientList: OptionType[];
  setEnteredClients?: React.Dispatch<React.SetStateAction<OptionType[]>>;
  setOnKeyDown?: React.Dispatch<React.SetStateAction<boolean>>;
}

const ClientSearch = ({
  clientSearch,
  onclientSearchChange,
  setClientList,
  clientList,
  setEnteredClients,
  setOnKeyDown
}: IProps) => {
  const AsyncTypeaheadWithOptionType = AsyncTypeahead as new (
    props: AsyncTypeaheadProps<OptionType>
  ) => AsyncTypeahead<OptionType>;

  const [clientMenuShow, setClientMenuShow] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const currentInputRef = useRef('');
  const pendingEnterRef = useRef(false);
  const selectClientRef = useRef(null);

  const [doClientRequest, { loading: clientLoading }] = useLazyQuery(
    GET_ATTENDEES,
    {
      fetchPolicy: 'network-only',
      onCompleted: (data: any) => {
        if (data?.attendees) {
          setClientList([...data.attendees]);
          if (pendingEnterRef.current) {
            setOnKeyDown?.(true);
            setEnteredClients?.([...data.attendees]);
            setClientMenuShow(false);
            pendingEnterRef.current = false;
          }
        } else {
          setClientList([]);
          if (pendingEnterRef.current) {
            setOnKeyDown?.(true);
            setEnteredClients?.([]);
            setClientMenuShow(false);
            pendingEnterRef.current = false;
          }
        }
        setIsSearching(false);
      },
      onError: () => {
        setClientList([]);
        setIsSearching(false);
        if (pendingEnterRef.current) {
          setOnKeyDown?.(true);
          setEnteredClients?.([]);
          setClientMenuShow(false);
          pendingEnterRef.current = false;
        }
      }
    }
  );

  const handleClientSearch = useCallback(
    query => {
      if (!query || query.trim().length < 2) {
        setClientList([]);
        return;
      }
      setClientList([]);
      const clientData = [{ id: undefined, name: query }];
      onclientSearchChange(clientData);
      doClientRequest({
        variables: {
          name: query.trim(),
          isClient: true,
          shouldExcludeActive: true
        }
      });
    },
    [doClientRequest, onclientSearchChange, setClientList]
  );
  const handleClientInputChange = useCallback(
    input => {
      currentInputRef.current = input;
      if (input.length === 0) {
        onclientSearchChange([{ id: null, name: '' }]);
        setClientList([]);
        setIsSearching(false);
      } else if (input.length < 2) {
        setClientMenuShow(false);
        setClientList([]);
        setIsSearching(false);
      } else {
        setClientMenuShow(true);
        setIsSearching(true);
      }
    },
    [onclientSearchChange, setClientList]
  );
  const handleKeyDown = (e: Event) => {
    const event = e as KeyboardEvent;
    if (event.key === 'Enter') {
      const currentInput = currentInputRef.current;
      if (clientList.length > 0 || !isSearching) {
        setOnKeyDown?.(true);
        setEnteredClients?.(clientList);
        setClientMenuShow(false);
        setIsSearching(false);
      } else if (currentInput && currentInput.trim().length >= 2) {
        pendingEnterRef.current = true;
        setClientList([]);
        doClientRequest({
          variables: {
            name: currentInput.trim(),
            isClient: true,
            shouldExcludeActive: true
          }
        });
      }
    }
  };

  return (
    <>
      <SearchWrapper
        isSearchListOpen={clientMenuShow}
        view={'day'}
        isStaffPage={true}
      >
        <div
          className="client_search_wrap provider_search_wrap"
          style={{ width: '100%' }}
        >
          <AsyncTypeaheadWithOptionType
            defaultInputValue={clientSearch}
            className="client-Provider_wrapper staff_wrapper waitlist_Wrapper"
            filterBy={() => true}
            ref={selectClientRef}
            id="search-attendees"
            labelKey={'displayName'}
            isLoading={isSearching || clientLoading}
            minLength={2}
            onSearch={handleClientSearch}
            options={clientList}
            placeholder={'Search Client'}
            onKeyDown={handleKeyDown}
            onChange={data => {
              onclientSearchChange(data);
            }}
            delay={300}
            renderMenuItemChildren={(option: OptionType) => (
              <p className="client-Provider_option">{option.displayName}</p>
            )}
            emptyLabel={<p className="client-Provider_results">No results</p>}
            promptText={
              <p className="client-Provider_search">Type to search...</p>
            }
            searchText={
              <p className="client-Provider_loader">
                <Loader />
              </p>
            }
            onInputChange={handleClientInputChange}
            useCache={false}
          />
          <img src={searchIcon} className="search-icon-waitList" alt="" />
        </div>
      </SearchWrapper>
    </>
  );
};
export default ClientSearch;
